import Vue from 'vue'
import Vuex from 'vuex'
import game from '@puzzleapps/wordsearch/src/store/modules/game'
import grid from '@puzzleapps/wordsearch/src/store/modules/grid'
import archive from '@puzzleapps/wordsearch/src/store/modules/archive'
import userSettings from '@puzzleapps/wordsearch/src/store/modules/userSettings'
import undoRedo from '@puzzleapps/wordsearch/src/store/modules/undoRedo'
import wordlist from '@puzzleapps/wordsearch/src/store/modules/wordlist'
import mouseDragger from '@puzzleapps/wordsearch/src/store/modules/mouseDragger'

import errors from '@puzzleapps/shared/src/store/modules/errors'
import notification from '@puzzleapps/shared/src/store/modules/notification'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    initialized: false,
    clientAppId: null,
  },
  modules: {
    grid,
    errors,
    notification,
    // cluelist,
    game,
    undoRedo,
    userSettings,
    mouseDragger,
    wordlist,
    archive,
  },
})
